import { render, staticRenderFns } from "./ListagemCompraDiretaSituacaoUnica.vue?vue&type=template&id=6b6ac754&scoped=true"
import script from "./ListagemCompraDiretaSituacaoUnica.vue?vue&type=script&lang=js"
export * from "./ListagemCompraDiretaSituacaoUnica.vue?vue&type=script&lang=js"
import style0 from "./ListagemCompraDiretaSituacaoUnica.vue?vue&type=style&index=0&id=6b6ac754&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ac754",
  null
  
)

export default component.exports